module.exports = __webpack_public_path__ + "static/media/educationalicon.3979e720.svg";